
@switch (displayType) {
  @case ('True/False') {
    @if (value === true) {
      <span>True</span>
    }
    @if (value === false) {
      <span>False</span>
    }
    <!--I don't think this is right fix, but will get things working for now, until can consult on how this was originally supposed to interact with the
    SummaryComponent.getQuestionValue value-->
    @if (value === 'Yes') {
      <span>True</span>
    }
    @if (value === 'No') {
      <span>False</span>
    }
  }
  @case ('Yes/No') {
    @if (value === true) {
      <span>Yes</span>
    }
    @if (value === false) {
      <span>No</span>
    }
    <!--I don't think this is right fix, but will get things working for now, until can consult on how this was originally supposed to interact with the
    SummaryComponent.getQuestionValue value-->
    @if (value === 'Yes') {
      <span>Yes</span>
    }
    @if (value === 'No') {
      <span>No</span>
    }
  }
  @case ('Other') {
    @if (value === true) {
      <span>{{otherChecked}}</span>
    }
    @if (value === false) {
      <span>{{otherUnchecked}}</span>
    }
    <!--I don't think this is right fix, but will get things working for now, until can consult on how this was originally supposed to interact with the
    SummaryComponent.getQuestionValue value-->
    @if (value === 'Yes') {
      <span>{{otherChecked}}</span>
    }
    @if (value === 'No') {
      <span>{{otherUnchecked}}</span>
    }
  }
  @default {
    {{value}}
  }
}
